import { createPortal } from "react-dom";

// Renders overlays (dialogs, full-screen backdrops) directly under <body>.
// Shell containers such as the sidebar and header use backdrop-filter /
// transform, which turn them into the containing block for position:fixed
// descendants — a fixed overlay rendered inside them would be clipped to
// their box and stacked under the rest of the page. Every fixed overlay
// opened from inside the shell must go through this component.
export default function ModalPortal({ children }) {
  return createPortal(children, document.body);
}
